import { useTranslation } from "react-i18next";
import { ao3Platforms } from "@/mocks/ao3Home";
import Ao3Reveal from "./Ao3Reveal";

export default function Ao3Platforms() {
  const { t } = useTranslation();

  return (
    <section id="ao3-platforms" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <Ao3Reveal className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-semibold tracking-[0.2em] text-primary-700 dark:text-primary-400">{t("platforms.badge")}</span>
          <h2 className="mt-3 font-heading text-2xl font-semibold text-foreground-950 md:text-4xl">{t("platforms.title")}</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{t("platforms.subtitle")}</p>
        </Ao3Reveal>

        <div className="mt-10 grid grid-cols-1 gap-4 md:mt-14 sm:grid-cols-2 lg:grid-cols-4">
          {ao3Platforms.map((platform, index) => (
            <Ao3Reveal key={platform.id} delay={index * 70}>
              <article className="flex h-full flex-col items-start gap-3 rounded-lg border border-background-200/70 bg-background-100/60 p-5 md:p-6">
                <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950">
                  <i className={`${platform.icon} text-2xl leading-none`} />
                </span>
                <h3 className="font-heading text-lg font-semibold text-foreground-950">
                  {platform.id === "harmonyos" ? "HarmonyOS" : platform.id === "ios" ? "iOS" : platform.id === "android" ? "Android" : "Windows"}
                </h3>
                <p className="text-sm leading-relaxed text-foreground-600">{t(`platforms.${platform.id}.desc`)}</p>
                <span className="mt-auto inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
                  <i className="ri-checkbox-circle-line text-sm leading-none" />
                  {t(`platforms.${platform.id}.caption`)}
                </span>
              </article>
            </Ao3Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}